import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './agent/home/home.component';
import { ResultComponent } from './agent/result/result.component';
import { CallbackComponent } from './callback/callback.component';
import { AuthGuardService } from './services/auth-guard.service';
import { HealthComponent } from './health/health.component';

const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent
  },
  { 
    path: '', 
    component: HomeComponent,
    canActivate: [AuthGuardService]
  },
  { 
    path: 'result', 
    component: ResultComponent
  },
  { 
    path: 'health', 
    component: HealthComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
